// Stage Dependency
export function areStageDependenciesSatisfied(dependsOnIds, stages) {
  if (!dependsOnIds) return true;
  return dependsOnIds.every(depId => {
    const stage = stages.find(s => s.stageId === depId);
    return stage && stage.status === 1;
  });
}

// Checkpoint Dependency
export function areCheckpointDependenciesSatisfied(dependsOnIds, completedCheckpointIds) {
  if (!dependsOnIds) return true;

  return dependsOnIds.every(id =>
    completedCheckpointIds?.includes(id)
  );
}
